import { videoEditor, webApi } from '@mi-front/api-clients';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useFragment } from '../hooks/useFragment';

/**
 * Preloads data required by secondary fragment tabs to keep tab switches responsive.
 */
export function FragmentViewPreload() {
  const { fragment } = useFragment();
  const queryClient = useQueryClient();

  useEffect(() => {
    const { id: fragmentId, stationId } = fragment;

    const projectsOptions = videoEditor.projectsListQueryOptions({
      sourceType: 'FRAGMENT',
      sourceId: fragmentId,
    });
    void queryClient.prefetchQuery(projectsOptions);

    const socialUploadsOptions =
      webApi.getFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId);
    void queryClient.prefetchQuery(socialUploadsOptions);

    const socialConnectionsOptions =
      webApi.getSocialConnectionsConnectionsForStationQueryOptions(stationId);
    void queryClient.prefetchQuery(socialConnectionsOptions);
  }, [fragment.id, fragment.stationId, queryClient]);

  return null;
}
